<script setup>
import { Icon } from '@components'

const emit = defineEmits('change')

const model = defineModel()

const props = defineProps({
    options: {
        type: Array,
        default: () => []
    }
})

const changeSelect = (value) => {
    model.value = value
    emit('change')
}
</script>

<template>
    <div class="flex gap-3 items-center">
        <Icon v-for="item in props.options" :key="item.value" :name="item.icon" size="28px" class="cursor-pointer" :class="[model === item.value ? 'text-[#7F56D9]' : 'text-[#98A2B3]']" @click="changeSelect(item.value)" />
    </div>
</template>